<template>
  <div class="w-full sm:max-w-368 px-16 sm:px-0">
    <Breadcrumb v-if="isEdit" :to="editPreviousRoute.path" :header="editPreviousRoute.header" />
    <slot v-else />
    <form class="flex flex-col mt-24" @submit.prevent="submitForm">
      <h1 class="text-h3 mb-24">Pick an image that best represents your Adventure</h1>
      <div class="flex flex-col list-none mb-8">
        <!-- cards are wrapped in a button for accessibility, keyboard and voiceover will not recognize them otherwise -->
        <button v-for="photo in photoList" :key="photo.key" aria-label="Image Select Button" class="mb-16 list-none">
          <Card
            class="h-112 border-2 border-solid border-grey-clickable w-full"
            title="Image Select Button"
            :clickable="true"
            :selected="photo.id == selectedPhotoData.id"
            @click="selectImageHandler(photo)"
          >
            <img :alt="photo.label" :src="photo.url + '?w=368'" class="w-full h-full object-cover" />
          </Card>
        </button>
      </div>
      <StickyButton :value="isEdit ? 'Save' : 'Next'" type="submit" />
    </form>
  </div>
</template>

<script lang="ts">
// components
import Card from '../../../components/card/Card.vue';
import StickyButton from '../../../components/sticky_button/StickyButton.vue';
import Breadcrumb from '../../../components/breadcrumb/Breadcrumb.vue';

export default {
  name: 'Photo',
  components: { Card, StickyButton, Breadcrumb },
  props: {
    adventureMetaData: {
      default: () => {},
      type: Object,
    },
    isEdit: {
      default: false,
      type: Boolean,
    },
  },
  data(): any {
    return {
      selectedPhotoData: this.$store.getters['adventures/adventureDraft'].adventureCategoryImage || {},
    };
  },
  computed: {
    editPreviousRoute(): { path: string; header: string } {
      if (Object.keys(this.$store.getters['adventures/pendingEdits']).length) {
        return { path: `/adventures/${this.$store.getters['adventures/adventureId']}/edit/category`, header: 'Category' };
      }
      return { path: `/adventures/${this.$store.getters['adventures/adventureId']}/edit/`, header: 'Cancel' };
    },
    photoList(): any {
      return this.adventureMetaData?.categories?.[0].adventureCategoryImages || [];
    },
  },
  methods: {
    submitForm(): any {
      if (this.selectedPhotoData.id) {
        this.setPhoto();
      } else {
        this.$emit('alert', 0, 'This question is required.');
        this.scrollToTop();
      }
    },
    async setPhoto() {
      await this.$store.dispatch('adventures/updateStore', { adventureCategoryImage: this.selectedPhotoData });
      this.$router.push({
        path: this.isEdit ? `/adventures/${this.$store.getters['adventures/adventureId']}/edit` : '/adventures/new/availability',
      });
    },
    selectImageHandler(photo): any {
      this.selectedPhotoData = photo;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  padding: 0;
}
</style>
